module.exports = __webpack_public_path__ + "reportLabAsset.8f39cf8a9161bed9a5a10c43d0be69e6.png";